<!-- 部门操作 -->
<template>
  <div class="store-modal-content">
    <div class="data_action_form">
      <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="formDataList">
        <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'"
          :tabslist="formDataList" @tabs="
            (val) => {
              showTabs = val
            }
          ">
          <template slot="tabs" slot-scope="scope">
            <div class="table_content_box">
              <!-- 主信息 -->
              <div v-if="scope.index == 0">
                <el-form size="mini" inline :model="sendDataInfo" label-width="150px" ref="sendDataInfo"
                  :show-message="false">
                  <el-form-item label="卡类型" prop="capId" :rules="[{ required: true, trigger: ['blur', 'change'] }]">

                    <label slot="label" :style="$common.labelStyle('卡类型')" v-html="$common.htmlLabel('卡类型')"></label>
                    <el-input ref="capNameInput" clearable v-model="sendDataInfo.capName" class="form_codition"
                      @keyup.enter.native="
                        openSearch(
                          '8820873997127708',
                          0,
                          'capName',
                          'capId,capName'
                        )
                        " @contextmenu.native="onCapNameRightClick" @click.native="onCapNameLeftClick">
                      <el-button @click="
                        openSearch(
                          '8820873997127708',
                          0,
                          'capName',
                          'capId,capName'
                        )
                        " slot="append" icon="el-icon-search"></el-button></el-input>
                  </el-form-item>
                  <el-form-item label="会员名字" prop="memName" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                    <label slot="label" :style="$common.labelStyle('会员名字')" v-html="$common.htmlLabel('会员名字')"></label>
                    <el-input ref="memNameInput" class="form_codition" v-model.trim="sendDataInfo.memName"
                      :maxlength="$store.state.inputLength" placeholder="填写会员名字"></el-input>
                  </el-form-item>
                  <el-form-item label="手机号" prop="memPhone" :rules="[
                    { required: true, message: '请输入手机号', trigger: ['blur', 'change'] },
                    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号格式', trigger: ['blur', 'change'] }
                  ]">
                    <label slot="label" :style="$common.labelStyle('手机号')" v-html="$common.htmlLabel('手机号')"></label>
                    <el-input ref="memPhoneInput" class="form_codition" v-model.trim="sendDataInfo.memPhone"
                      :maxlength="11" placeholder="填写手机号" type="number" @blur="validatePhone"
                      @input="onPhoneInput"></el-input>
                  </el-form-item>
                  <el-form-item label="性别" prop="memSex" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                    <label slot="label" :style="$common.labelStyle('性别')" v-html="$common.htmlLabel('性别')"></label>
                    <el-select ref="memSexInput" v-model="sendDataInfo.memSex" placeholder="请选择" class="form_codition"
                      :rules="[{ required: true, trigger: ['blur', 'change'] }]" @change="handleSexSelect">
                      <el-option label="男" :value="'男'"></el-option>
                      <el-option label="女" :value="'女'"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="身份证" prop="memIdcard" :rules="[
                    { required: true, message: '请输入身份证号', trigger: ['blur', 'change'] },
                    { validator: validateIdCard, trigger: ['blur', 'change'] }
                  ]">
                    <label slot="label" :style="$common.labelStyle('身份证')" v-html="$common.htmlLabel('身份证')"></label>
                    <el-input ref="memIdcardInput" class="form_codition" v-model.trim="sendDataInfo.memIdcard"
                      :maxlength="18" placeholder="填写身份证" @blur="onIdCardInput" @change="onIdCardInput"
                      @input="onIdCardInputChange"></el-input>
                  </el-form-item>
                  <el-form-item label="生日" prop="memBirth">
                    <label slot="label" :style="$common.labelStyle('生日')" v-html="$common.htmlLabel('生日')"></label>
                    <el-input ref="memBirthInput" class="form_codition" v-model.trim="sendDataInfo.memBirth"
                      placeholder="填写生日"></el-input>
                  </el-form-item>



                  <el-form-item label="储值密码" prop="storedPwd">
                    <label slot="label" :style="$common.labelStyle('储值密码')" v-html="$common.htmlLabel('储值密码')"></label>
                    <el-input ref="storedPwdInput" class="form_codition" v-model.trim="sendDataInfo.storedPwd"
                      :maxlength="$store.state.inputLength" placeholder="填写储值密码" type="password"
                      autocomplete="new-password" autocapitalize="off" spellcheck="false"></el-input>
                  </el-form-item>

                  <div>
                    <el-form-item label="备注" prop="remark">
                      <label slot="label" :style="$common.labelStyle('备注')" v-html="$common.htmlLabel('备注')"></label>
                      <el-input ref="remarkInput" type="textarea" style="min-width: 600px !important"
                        v-model.trim="sendDataInfo.remark" :maxlength="$store.state.inputLength"
                        placeholder="填写备注"></el-input>
                    </el-form-item>
                  </div>
                  <div>
                                      <el-form-item label="住址" prop="memAddress">
                    <label slot="label" :style="$common.labelStyle('住址')" v-html="$common.htmlLabel('住址')"></label>
                    <el-input ref="memAddressInput" type="textarea" style="min-width: 600px !important"
                      v-model.trim="sendDataInfo.memAddress" :maxlength="$store.state.inputLength"
                      placeholder="填写住址" @contextmenu.native="onAddressRightClick"></el-input>
                  </el-form-item>
                  </div>
                </el-form>
              </div>
            </div>
          </template>
        </v-tabs>
      </el-card>
    </div>
    <div class="dialog-footer">
      <!-- <el-button ref="cancelButton" tabindex="0" @click="drawerCancel">取 消</el-button> -->
      <el-button ref="saveButton" tabindex="0" type="primary" @click="sendDataAction()">保 存</el-button>

    </div>

    <!-- 检索方案 -->
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
      :modal-append-to-body="true" :append-to-body="true" @close="closeChild">
      <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel"
        @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue"
export default {
  props: ["actionData"],
  name: "penetrateCashierModal",
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme,
  },
  data() {
    //这里存放数据
    return {
      dataActionBox: {
        actionType: 0, // 0新增，1修改
      },
      sendDataInfo: {
        capId: "",
        capName: "",
        memBirth: "",
        memIdcard: "",
        memName: "",
        memPhone: "",
        memSex: "",
        memState: 1,
        // pointBalance: "",
        // pointCheck: "",
        storeName: "",
        storeId: "",
        // storedBalance: "",
        // storedCheck: "",
        storedPwd: "",
        remark: "",
        memAddress: "",
      },
      formDataList: [],
      showTabs: "",
      DialogVisible: false, //判断是否打开检索方案弹框
      seTitle: "", //检索方案的名称
      seType: "", //检索方案查询条件字段
      seWidth: "", //检索方案弹框的宽度
      seTitle: "", //检索方案的名称
      sField: "", //赋值字段
      parentSearchData: {}, //检索方案补充的查询列表的查询条件
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    async openBox() {
      if (this.actionData.cate == 0) {
        this.showTabs = "新增会员信息"
        this.formDataList = [
          {
            jciName: "新增会员信息",
            jurconfigform: [],
          },
        ]

        // 设置storeId
        if (this.actionData.storeId) {
          this.sendDataInfo.storeId = this.actionData.storeId;
        }
        console.log(this.actionData, 'actionData');
      }
      this.dataActionBox.actionType = this.actionData.cate;

      // 等待下一个DOM更新周期，确保组件已经渲染
      await this.$nextTick();
      // 再等待一个短暂的时间，确保弹窗完全展开
      setTimeout(() => {
        this.focusToField('capNameInput');
      }, 100);
    },

    async sendDataAction() {
      // 表单验证
      this.$refs.sendDataInfo.validate(async (valid) => {
        if (valid) {
          // 额外验证手机号和身份证
          if (!this.validatePhoneNumber(this.sendDataInfo.memPhone)) {
            this.$message.error('请输入正确的手机号格式');
            return;
          }

          if (!this.validateIdCardNumber(this.sendDataInfo.memIdcard)) {
            this.$message.error('请输入正确的身份证号格式');
            return;
          }

          let sendData = JSON.parse(JSON.stringify(this.sendDataInfo))

          try {
            let responseData
            // 如果是新增
            if (this.dataActionBox.actionType == 0) {
              responseData = await this.$http.addMembermast(sendData)
            }
            // 如果是编辑
            else if (this.dataActionBox.actionType == 1) {
              responseData = await this.$http.updMembermast(sendData)
            }

            if (responseData.status == 200) {
              this.$message({
                message:
                  this.dataActionBox.actionType == 0 ? "新增成功" : "编辑成功",
                type: "success",
              })
              this.$emit("drawerCancel", false)
              this.$emit("toDetail", responseData.result)
            } else {
              this.$message({
                message: responseData.message,
                type: "error",
              })
            }
          } catch (error) {
            console.error("error", error)
            this.$message({
              message: "操作失败",
              type: "error",
            })
          }
        } else {
          this.$message({
            message: "请填写必填项",
            type: "error",
          })
          return false
        }
      })
    },
    //检索方案获取的数据清除
    clear(val) {
      if (val) {
        var arr = val.split(",")
        arr.forEach((item) => {
          this.$set(this.getRequestData, item, "")
        })
      }
    },
    //获取检索方案弹框宽度
    getSeWidth(e) {
      this.seWidth = e + "%"
    },
    //获取检索方案弹框名称
    getSearchName(e) {
      this.seTitle = e
    },
    // 检索Id, 索引(表格中), 标识
    openSearch(sId, index, type, sField) {
      this.seId = sId //检索方案Id
      this.sField = sField //赋值字段
      this.DialogVisible = true //判断是否打开弹框
      this.seType = type
      this.focusToField('memNameInput')
    },

    //检索方案返回的数据
    changeInputModel(val) {
      if (val != "" || val != undefined) {
        this.DialogVisible = false
        this.paramValue(val) //赋值字段，赋值
      }
    },
    // 赋值字段
    paramValue(val) {
      let arr = this.sField.split(",")
      arr.forEach((item) => {
        this.sendDataInfo[item] = val[item]
      })
    },
    //关闭提取、检索方案弹框关闭 创建键盘事件
    closeChild() {
      addEventListener("keyup", this.keyUp) //创建监听键盘事件
    },

    drawerCancel() {
      this.$emit("drawerCancel", false)
    },
    onIdCardInput() {
      const id = this.sendDataInfo.memIdcard;
      let birth = '';
      if (/^\d{15}$/.test(id)) {
        // 15位身份证
        birth = '19' + id.substr(6, 6);
        birth = birth.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
      } else if (/^\d{17}[\dXx]$/.test(id)) {
        // 18位身份证
        birth = id.substr(6, 8);
        birth = birth.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
      }
      if (birth) {
        this.sendDataInfo.memBirth = birth;
      }
    },

    // 身份证输入时处理
    onIdCardInputChange() {
      // 自动转换为大写
      this.sendDataInfo.memIdcard = this.sendDataInfo.memIdcard.toUpperCase();

      // 实时验证身份证格式
      if (this.sendDataInfo.memIdcard.length === 15 || this.sendDataInfo.memIdcard.length === 18) {
        this.$nextTick(() => {
          this.$refs.sendDataInfo.validateField('memIdcard');
        });
      }
    },

    // 身份证校验方法
    validateIdCard(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入身份证号'));
        return;
      }

      // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
      const regIdCard = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (!regIdCard.test(value)) {
        callback(new Error('身份证号码格式不正确'));
        return;
      }

      // 省份代码
      const provinceCode = value.substring(0, 2);
      const validProvinceCodes = ['11', '12', '13', '14', '15', '21', '22', '23', '31', '32', '33', '34', '35', '36', '37', '41', '42', '43', '44', '45', '46', '50', '51', '52', '53', '54', '61', '62', '63', '64', '65', '71', '81', '82'];
      if (!validProvinceCodes.includes(provinceCode)) {
        callback(new Error('身份证号码地区码不正确'));
        return;
      }

      // 出生日期验证
      let birthDate;
      if (value.length === 15) {
        // 15位身份证号码：6位地区码+6位出生日期+3位顺序号
        birthDate = '19' + value.substring(6, 12);
      } else {
        // 18位身份证号码：6位地区码+8位出生日期+3位顺序号+1位校验码
        birthDate = value.substring(6, 14);
      }

      // 解析出生日期
      const year = parseInt(birthDate.substring(0, 4));
      const month = parseInt(birthDate.substring(4, 6));
      const day = parseInt(birthDate.substring(6, 8));

      // 验证日期是否合法
      const date = new Date(year, month - 1, day);
      if (date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day) {
        callback(new Error('身份证号码出生日期不正确'));
        return;
      }

      // 验证年龄范围（0-120岁）
      const currentYear = new Date().getFullYear();
      if (year < currentYear - 120 || year > currentYear) {
        callback(new Error('身份证号码出生年份不合理'));
        return;
      }

      // 18位身份证需要验证最后一位校验位
      if (value.length === 18) {
        const idCardWi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]; // 加权因子
        const idCardY = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']; // 校验字符
        let idCardWiSum = 0; // 用来保存前17位各自乘加权因子后的总和

        // 计算校验位
        for (let i = 0; i < 17; i++) {
          idCardWiSum += parseInt(value.substring(i, i + 1)) * idCardWi[i];
        }

        const idCardMod = idCardWiSum % 11; // 计算出校验码所在位置
        const idCardLast = value.substring(17).toUpperCase(); // 得到最后一位身份证号码（转大写）

        // 检验校验位
        if (idCardLast !== idCardY[idCardMod]) {
          callback(new Error('身份证号码校验位错误'));
          return;
        }

        // // 获取性别
        // const genderCode = parseInt(value.substring(16, 17));
        // const gender = genderCode % 2 === 0 ? '女' : '男';

        // // 如果已经选择了性别，验证是否与身份证号码相符
        // if (this.sendDataInfo.memSex && this.sendDataInfo.memSex !== gender) {
        //   callback(new Error('性别与身份证号码不符'));
        //   return;
        // } else {
        //   // 自动设置性别
        //   this.sendDataInfo.memSex = gender;
        // }

      } else {
        // 15位身份证
        // 获取性别
        const genderCode = parseInt(value.substring(14, 15));
        const gender = genderCode % 2 === 0 ? '女' : '男';

        // 如果已经选择了性别，验证是否与身份证号码相符
        if (this.sendDataInfo.memSex && this.sendDataInfo.memSex !== gender) {
          callback(new Error('性别与身份证号码不符'));
          return;
        } else {
          // 自动设置性别
          this.sendDataInfo.memSex = gender;
        }
      }

      // 设置出生日期
      if (value.length === 15) {
        this.sendDataInfo.memBirth = `19${birthDate.substring(0, 2)}-${birthDate.substring(2, 4)}-${birthDate.substring(4, 6)}`;
      } else {
        this.sendDataInfo.memBirth = `${birthDate.substring(0, 4)}-${birthDate.substring(4, 6)}-${birthDate.substring(6, 8)}`;
      }

      callback();
    },

    // 手机号校验方法
    validatePhone() {
      const phone = this.sendDataInfo.memPhone;
      if (phone && !/^1[3-9]\d{9}$/.test(phone)) {
        this.$message.warning('请输入正确的手机号格式');
      }
    },

    // 手机号格式验证（返回布尔值）
    validatePhoneNumber(phone) {
      return /^1[3-9]\d{9}$/.test(phone);
    },

    // 卡类型右键点击处理
    onCapNameRightClick(event) {
      event.preventDefault(); // 阻止默认右键菜单
      // 聚焦到会员名字输入框
      this.$nextTick(() => {
        if (this.$refs.memNameInput) {
          this.$refs.memNameInput.focus();
          // 选中输入框内容
          const inputElement = this.$refs.memNameInput.$el.querySelector('input');
          if (inputElement) {
            inputElement.select();
          }
        }
      });
    },

    // 卡类型左键点击处理
    onCapNameLeftClick(event) {
      console.log('卡类型字段左键点击事件触发');
      // 聚焦到保存按钮
      this.$nextTick(() => {
        console.log('卡类型字段左键点击，准备聚焦到保存按钮');
        
        // 尝试多种方式查找保存按钮
        let saveButton = null;
        
        // 方法1：通过ref
        if (this.$refs.saveButton) {
          saveButton = this.$refs.saveButton;
          console.log('通过ref找到保存按钮');
        }
        // 方法2：通过DOM查询
        else {
          saveButton = this.$el.querySelector('button[type="primary"]');
          if (saveButton) {
            console.log('通过DOM查询找到保存按钮');
          }
        }
        // 方法3：通过文本内容
        if (!saveButton) {
          const allButtons = this.$el.querySelectorAll('button');
          for (let button of allButtons) {
            if (button.textContent.includes('保存') || button.textContent.includes('保 存')) {
              saveButton = button;
              console.log('通过文本内容找到保存按钮');
              break;
            }
          }
        }
        
        if (saveButton) {
          console.log('开始聚焦保存按钮');
          if (typeof saveButton.focus === 'function') {
            saveButton.focus();
          } else if (saveButton.$el) {
            saveButton.$el.focus();
          } else {
            saveButton.focus();
          }
          console.log('保存按钮聚焦完成');
        } else {
          console.log('无法找到保存按钮');
        }
      });
    },

    // 身份证号格式验证（返回布尔值）
    validateIdCardNumber(idCard) {
      if (!idCard) return false;

      // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
      const regIdCard = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (!regIdCard.test(idCard)) {
        return false;
      }

      // 18位身份证需要验证最后一位校验位
      if (idCard.length === 18) {
        const idCardWi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]; // 加权因子
        const idCardY = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']; // 校验字符
        let idCardWiSum = 0; // 用来保存前17位各自乘加权因子后的总和

        for (let i = 0; i < 17; i++) {
          idCardWiSum += parseInt(idCard.substring(i, i + 1)) * idCardWi[i];
        }

        const idCardMod = idCardWiSum % 11; // 计算出校验码所在位置
        const idCardLast = idCard.substring(17); // 得到最后一位身份证号码

        // 如果等于2，则说明校验码是x，否则是数字
        if (idCardMod === 2) {
          return idCardLast === 'X' || idCardLast === 'x';
        } else {
          return idCardLast === idCardY[idCardMod];
        }
      } else {
        // 15位身份证
        return true;
      }
    },

    // 手机号输入处理
    onPhoneInput() {
      // 限制只能输入数字
      this.sendDataInfo.memPhone = this.sendDataInfo.memPhone.replace(/\D/g, '');
      // 限制长度为11位
      if (this.sendDataInfo.memPhone.length > 11) {
        this.sendDataInfo.memPhone = this.sendDataInfo.memPhone.substring(0, 11);
      }

      // 实时验证手机号格式
      if (this.sendDataInfo.memPhone.length === 11) {
        this.$nextTick(() => {
          this.$refs.sendDataInfo.validateField('memPhone');
        });
      }
    },

    // 聚焦到卡类型输入框
    focusToCapName() {
      const capNameInput = this.$el.querySelector('input[placeholder*="卡类型"]');
      if (capNameInput) {
        capNameInput.focus();
        capNameInput.select();
      }
    },

    // 处理键盘事件
    handleKeyDown(event) {
      // 检查是否在保存按钮上
      const target = event.target;
      const isSaveButton = target.tagName === 'BUTTON' &&
        (target.textContent.includes('保存') || target.textContent.includes('保 存'));

      if (isSaveButton) {
        if (event.key === 'Enter') {
          // 在保存按钮上按回车，执行保存
          event.preventDefault();
          this.sendDataAction();
          return;
        } else if (event.key === 'ArrowRight') {
          // 在保存按钮上按右方向键，循环到第一个字段
          event.preventDefault();
          this.focusToField('capNameInput');
          return;
        } else if (event.key === 'ArrowLeft') {
          // 在保存按钮上按左方向键，导航到最后一个字段
          event.preventDefault();
          this.focusToField('memAddressInput');
          return;
        }
        // 对于Tab键，让浏览器默认行为工作，不阻止
        return;
      }

      // 检查是否在输入框中
      const isInputElement = target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.contentEditable === 'true' ||
        target.closest('.el-input') ||
        target.closest('.el-textarea') ||
        target.closest('.el-select');

      if (isInputElement) {
        // 在输入框中，处理方向键导航
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          console.log('向右导航，当前字段:', this.getCurrentFocusedField());
          this.navigateToNextField();
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          console.log('向左导航，当前字段:', this.getCurrentFocusedField());
          this.navigateToPreviousField();
        } else if (event.key === 'Enter') {
          // 如果是在下拉框中按回车
          const isSelect = target.closest('.el-select');
          if (isSelect) {
            // 对于select组件，让Element UI先处理第一次回车（打开下拉框）
            // 用户需要再次按回车来选择选项并跳转
            // 这里我们不做特殊处理，让Element UI的默认行为工作
          }
        }else if (event.key === 'Escape') {
          this.DialogVisible = false;
        }
        // 对于Tab键，让浏览器默认行为工作，不阻止
      }
    },

    // 获取当前聚焦的字段名称（调试用）
    getCurrentFocusedField() {
      const activeElement = document.activeElement;
      const fields = [
        'capNameInput',    // 卡类型
        'memNameInput',    // 会员名字
        'memPhoneInput',   // 手机号
        'memSexInput',     // 性别
        'memIdcardInput',  // 身份证
        'memBirthInput',   // 生日
        'storedPwdInput',  // 储值密码
        'remarkInput',     // 备注
        'memAddressInput'  // 住址
      ];

      for (let i = 0; i < fields.length; i++) {
        const ref = this.$refs[fields[i]];
        if (ref) {
          if (ref.$el && ref.$el.contains(activeElement)) {
            return fields[i];
          }
          if (ref === activeElement) {
            return fields[i];
          }
          if (ref.$el) {
            const inputElement = ref.$el.querySelector('input') || ref.$el.querySelector('textarea');
            if (inputElement === activeElement) {
              return fields[i];
            }
          }
        }
      }
      return null;
    },



          // 导航到下一个字段
      navigateToNextField() {
        const fields = [
          'capNameInput',    // 卡类型
          'memNameInput',    // 会员名字
          'memPhoneInput',   // 手机号
          'memSexInput',     // 性别
          'memIdcardInput',  // 身份证
          'memBirthInput',   // 生日
          'storedPwdInput',  // 储值密码
          'remarkInput',     // 备注
          'memAddressInput'  // 住址
        ];

        // 找到当前聚焦的元素
        const activeElement = document.activeElement;
        let currentField = null;

        // 遍历所有字段，找到当前聚焦的字段
        for (let i = 0; i < fields.length; i++) {
          const ref = this.$refs[fields[i]];
          if (ref) {
            // 检查是否包含当前聚焦的元素
            if (ref.$el && ref.$el.contains(activeElement)) {
              currentField = fields[i];
              break;
            }
            // 检查ref本身是否是当前聚焦的元素
            if (ref === activeElement) {
              currentField = fields[i];
              break;
            }
            // 检查ref的input元素是否是当前聚焦的元素
            if (ref.$el) {
              const inputElement = ref.$el.querySelector('input') || ref.$el.querySelector('textarea');
              if (inputElement === activeElement) {
                currentField = fields[i];
                break;
              }
            }
          }
        }

        if (currentField) {
          const currentIndex = fields.indexOf(currentField);
          // 如果是最后一个字段，聚焦到保存按钮
          if (currentField === 'memAddressInput') {
            console.log(`导航: 从 ${currentField} 到保存按钮`);
            this.focusToSaveButton();
          } else {
            const nextIndex = currentIndex + 1;
            console.log(`导航: 从 ${currentField} (索引${currentIndex}) 到 ${fields[nextIndex]} (索引${nextIndex})`);
            this.focusToField(fields[nextIndex]);
          }
        } else {
          // 如果没有找到当前字段，聚焦到第一个字段
          console.log('未找到当前字段，聚焦到第一个字段');
          this.focusToField(fields[0]);
        }
      },

          // 导航到上一个字段
      navigateToPreviousField() {
        const fields = [
          'capNameInput',    // 卡类型
          'memNameInput',    // 会员名字
          'memPhoneInput',   // 手机号
          'memSexInput',     // 性别
          'memIdcardInput',  // 身份证
          'memBirthInput',   // 生日
          'storedPwdInput',  // 储值密码
          'remarkInput',     // 备注
          'memAddressInput'  // 住址
        ];

        // 检查是否在保存按钮上
        const activeElement = document.activeElement;
        const isSaveButton = activeElement.tagName === 'BUTTON' && 
                           (activeElement.textContent.includes('保存') || activeElement.textContent.includes('保 存'));
        
        if (isSaveButton) {
          // 从保存按钮导航到最后一个字段
          console.log('从保存按钮导航到最后一个字段');
          this.focusToField('memAddressInput');
          return;
        }

        // 找到当前聚焦的字段
        let currentField = null;

        // 遍历所有字段，找到当前聚焦的字段
        for (let i = 0; i < fields.length; i++) {
          const ref = this.$refs[fields[i]];
          if (ref) {
            // 检查是否包含当前聚焦的元素
            if (ref.$el && ref.$el.contains(activeElement)) {
              currentField = fields[i];
              break;
            }
            // 检查ref本身是否是当前聚焦的元素
            if (ref === activeElement) {
              currentField = fields[i];
              break;
            }
            // 检查ref的input元素是否是当前聚焦的元素
            if (ref.$el) {
              const inputElement = ref.$el.querySelector('input') || ref.$el.querySelector('textarea');
              if (inputElement === activeElement) {
                currentField = fields[i];
                break;
              }
            }
          }
        }

        if (currentField) {
          const currentIndex = fields.indexOf(currentField);
          const previousIndex = (currentIndex - 1 + fields.length) % fields.length;
          this.focusToField(fields[previousIndex]);
        } else {
          // 如果没有找到当前字段，聚焦到最后一个字段
          this.focusToField(fields[fields.length - 1]);
        }
      },




          // 聚焦到指定字段
      focusToField(fieldName) {
        console.log(`尝试聚焦到字段: ${fieldName}`);
        this.$nextTick(() => {
          const ref = this.$refs[fieldName];
          if (!ref) {
            console.log(`字段 ${fieldName} 的ref不存在`);
            return;
          }
          
          // 对于Element UI组件，需要找到实际的input元素
          let inputElement = null;
          
          if (ref.$el) {
            // 查找input或textarea元素
            inputElement = ref.$el.querySelector('input') || ref.$el.querySelector('textarea');
            
            // 如果是el-select，需要特殊处理
            if (ref.$el.classList.contains('el-select')) {
              // 对于select，我们聚焦到select组件本身
              console.log(`聚焦到select组件: ${fieldName}`);
              ref.focus();
              return;
            }
          }
          
          if (inputElement) {
            console.log(`聚焦到input元素: ${fieldName}`);
            inputElement.focus();
            inputElement.select();
          } else {
            // 如果找不到input元素，尝试直接聚焦ref
            if (typeof ref.focus === 'function') {
              console.log(`直接聚焦ref: ${fieldName}`);
              ref.focus();
            } else {
              console.log(`无法聚焦字段: ${fieldName}`);
            }
          }
        });
      },

      // 聚焦到保存按钮
      focusToSaveButton() {
        console.log('尝试聚焦到保存按钮');
        this.$nextTick(() => {
          // 方法1：通过ref获取
          const saveButton = this.$refs.saveButton;
          if (saveButton) {
            console.log('通过ref找到保存按钮');
            if (typeof saveButton.focus === 'function') {
              saveButton.focus();
            } else if (saveButton.$el) {
              saveButton.$el.focus();
            } else {
              saveButton.focus();
            }
            return;
          }
          
          // 方法2：通过DOM查询获取
          const buttonElement = this.$el.querySelector('button[type="primary"]');
          if (buttonElement) {
            console.log('通过DOM查询找到保存按钮');
            buttonElement.focus();
            return;
          }
          
          // 方法3：通过文本内容查找
          const allButtons = this.$el.querySelectorAll('button');
          for (let button of allButtons) {
            if (button.textContent.includes('保存') || button.textContent.includes('保 存')) {
              console.log('通过文本内容找到保存按钮');
              button.focus();
              return;
            }
          }
          
          console.log('无法找到保存按钮');
        });
      },

      // 处理住址字段的Tab键（已废弃，由handleModalTabKey统一处理）
      handleAddressTab(event) {
        // 不再单独处理，由弹窗级别的Tab键处理统一管理
      },

      // 处理保存按钮的Tab键（已废弃，由handleModalTabKey统一处理）
      handleSaveButtonTab(event) {
        // 不再单独处理，由弹窗级别的Tab键处理统一管理
      },

      // 住址字段右键点击处理
      onAddressRightClick(event) {
        event.preventDefault(); // 阻止默认右键菜单
        console.log('住址字段右键点击事件触发');
        
        // 直接查找并聚焦保存按钮
        this.$nextTick(() => {
          console.log('住址字段右键点击，准备聚焦到保存按钮');
          
          // 尝试多种方式查找保存按钮
          let saveButton = null;
          
          // 方法1：通过ref
          if (this.$refs.saveButton) {
            saveButton = this.$refs.saveButton;
            console.log('通过ref找到保存按钮');
          }
          // 方法2：通过DOM查询
          else {
            saveButton = this.$el.querySelector('button[type="primary"]');
            if (saveButton) {
              console.log('通过DOM查询找到保存按钮');
            }
          }
          // 方法3：通过文本内容
          if (!saveButton) {
            const allButtons = this.$el.querySelectorAll('button');
            for (let button of allButtons) {
              if (button.textContent.includes('保存') || button.textContent.includes('保 存')) {
                saveButton = button;
                console.log('通过文本内容找到保存按钮');
                break;
              }
            }
          }
          
          if (saveButton) {
            console.log('开始聚焦保存按钮');
            if (typeof saveButton.focus === 'function') {
              saveButton.focus();
            } else if (saveButton.$el) {
              saveButton.$el.focus();
            } else {
              saveButton.focus();
            }
            console.log('保存按钮聚焦完成');
          } else {
            console.log('无法找到保存按钮');
          }
        });
      },

    // 聚焦到下一个输入框
    focusNextInput(refName) {
      this.$nextTick(() => {
        if (this.$refs[refName]) {
          this.$refs[refName].focus();
        }
      });
    },
    // 处理回车键
    handleEnterKey() {
      // 如果当前在最后一个字段，则保存
      const currentField = this.getCurrentFocusedField();
      if (currentField === 'memAddressInput') {
        this.sendDataAction();
      } else {
        // 否则导航到下一个字段
        this.navigateToNextField();
      }
    },
    // 处理性别选择
    handleSexSelect() {
      // 选择后延迟跳转，给用户时间再次按回车
      console.log('性别已选择:', this.sendDataInfo.memSex);
      setTimeout(() => {
        // 如果用户没有在1秒内按回车，则自动跳转到下一个字段
        this.navigateToNextField();
      }, 1000);
    },

    // 处理弹窗内Tab键循环聚焦
    handleModalTabKey(event) {
      // 只处理Tab键
      if (event.key !== 'Tab') {
        return;
      }

      // 阻止默认的Tab键行为
      event.preventDefault();

      // 定义可聚焦元素的顺序
      const focusableElements = [
        'capNameInput',    // 卡类型
        'memNameInput',    // 会员名字
        'memPhoneInput',   // 手机号
        'memSexInput',     // 性别
        'memIdcardInput',  // 身份证
        'memBirthInput',   // 生日
        'storedPwdInput',  // 储值密码
        'remarkInput',     // 备注
        'memAddressInput', // 住址
        'saveButton'       // 保存按钮
      ];

      // 找到当前聚焦的元素
      const activeElement = document.activeElement;
      let currentIndex = -1;

      // 遍历所有可聚焦元素，找到当前聚焦的元素
      for (let i = 0; i < focusableElements.length; i++) {
        const ref = this.$refs[focusableElements[i]];
        if (ref) {
          // 检查是否包含当前聚焦的元素
          if (ref.$el && ref.$el.contains(activeElement)) {
            currentIndex = i;
            break;
          }
          // 检查ref本身是否是当前聚焦的元素
          if (ref === activeElement) {
            currentIndex = i;
            break;
          }
          // 检查ref的input元素是否是当前聚焦的元素
          if (ref.$el) {
            const inputElement = ref.$el.querySelector('input') || ref.$el.querySelector('textarea');
            if (inputElement === activeElement) {
              currentIndex = i;
              break;
            }
          }
        }
      }

      // 如果没找到当前聚焦的元素，从第一个开始
      if (currentIndex === -1) {
        currentIndex = 0;
      }

      // 计算下一个要聚焦的元素索引
      let nextIndex;
      if (event.shiftKey) {
        // Shift+Tab，向前循环
        nextIndex = (currentIndex - 1 + focusableElements.length) % focusableElements.length;
      } else {
        // Tab，向后循环
        nextIndex = (currentIndex + 1) % focusableElements.length;
      }

      // 聚焦到下一个元素
      const nextElementName = focusableElements[nextIndex];
      console.log(`Tab键导航: 从 ${focusableElements[currentIndex]} 到 ${nextElementName}`);

      if (nextElementName === 'saveButton') {
        this.focusToSaveButton();
      } else {
        this.focusToField(nextElementName);
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.openBox()

  },
  // 生命周期 - 挂载完成
  mounted() {
    // 添加键盘事件监听
    window.addEventListener('keydown', this.handleKeyDown);
    // 添加弹窗内Tab键事件监听
    this.$el.addEventListener('keydown', this.handleModalTabKey);
  },
  // 生命周期 - 销毁前
  beforeDestroy() {
    // 移除键盘事件监听
    window.removeEventListener('keydown', this.handleKeyDown);
    document.removeEventListener('keydown', this.handleKeyDown);
    // 移除弹窗内Tab键事件监听
    if (this.$el) {
      this.$el.removeEventListener('keydown', this.handleModalTabKey);
    }
  },
}
</script>
<style scoped>
.store-modal-content {
  padding: 20px;
  max-height: 70vh;
  overflow-y: auto;
}

/* 设置所有label颜色为#606266 */
:deep(.el-form-item__label) {
  color: #606266 !important;
}

:deep(.el-form-item__label label) {
  color: #606266 !important;
}

.data_action_form {
  width: 100%;
}

.table_content_tag {
  margin-right: 1rem;
}

.el-tabs--border-card_new {
  height: auto;
  overflow-y: visible;
}

.btns {
  display: flex;
  position: absolute;
  z-index: 999;
  padding-left: 10px;
  padding-top: 2px;
}

::v-deep.xunjia tr {
  height: 39px !important;
}

#smManrange {
  width: 100%;
  display: flex;
  padding-left: 83px;
  margin-bottom: 10px;
}

::v-deep #smManrange .el-form-item__content {
  width: 100% !important;
}

::v-deep #smManrange .el-textarea__inner {
  width: 76% !important;
  margin-right: 20px;
  font-size: 12px;
}

.cmContent {
  padding-left: 10px;
  width: 90%;
}

.mem-day-type-content {
  text-align: center;
  padding: 20px 0;
}

.mem-day-type-content .el-radio {
  margin: 0 20px;
  font-size: 16px;
}

.mem-day-content {
  max-height: 400px;
  overflow-y: auto;
}

.mem-day-content p {
  margin-bottom: 15px;
  font-weight: bold;
  color: #333;
}

.mem-day-content .el-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.mem-day-content .el-checkbox {
  margin-right: 15px;
  margin-bottom: 10px;
  min-width: 80px;
}

.mem-day-type-section {
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.mem-day-type-section h4 {
  margin-bottom: 10px;
  color: #333;
  font-size: 14px;
}

.mem-day-type-section .el-radio {
  margin-right: 20px;
  font-size: 14px;
}

.mem-day-detail-section h4 {
  margin-bottom: 15px;
  color: #333;
  font-size: 14px;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: #fff;
  height: 46px;
  padding: 5px 10px;
  margin-top: 20px;
  border-top: 1px solid #eee;
  position: relative;
  z-index: 10;
}

/* 确保按钮可以被聚焦 */
.dialog-footer .el-button {
  outline: none;
}



:deep(.el-form .el-form-item) {
  margin-bottom: 15px !important;
  margin-top: 5px !important;
}

/* 必填字段的标签样式 */
:deep(.el-form-item.is-required .el-form-item__label::before) {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}

/* 输入框验证状态样式 */
:deep(.el-form-item.is-error .el-input__inner) {
  border-color: #f56c6c;
}

:deep(.el-form-item.is-success .el-input__inner) {
  border-color: #67c23a;
}

/* 手机号和身份证输入框的特殊样式 */
:deep(.el-form-item[prop="memPhone"] .el-input__inner),
:deep(.el-form-item[prop="memIdcard"] .el-input__inner) {
  font-family: 'Courier New', monospace;
  letter-spacing: 1px;
}
</style>